/* Curved hero brand marquee: static until touched; drag/fling spins it at the
   pointer's velocity, then eases into the normal cruise speed. */
(function () {
  function init(strip) {
    var track = strip.querySelector('[data-marquee-track]');
    if (!track) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var baseV = reduced ? 0 : parseFloat(track.getAttribute('data-speed') || '0.6');
    var x = 0;
    var v = baseV; /* slow cruise from load */
    var dragging = false;
    var lastPointerX = 0;
    var samples = [];
    var runWidth = 0;

    function measure() {
      runWidth = track.scrollWidth / 2;
    }
    measure();
    window.addEventListener('resize', measure);

    track.querySelectorAll('img').forEach(function (img) {
      img.draggable = false;
      if (!img.complete) img.addEventListener('load', measure, { once: true });
    });

    var lastTs = null;
    function frame(ts) {
      /* v is px per 60fps-frame; scale by real frame time so speed is
         identical on 60Hz and 120Hz displays */
      var dt = 1;
      if (lastTs !== null) dt = Math.min((ts - lastTs) / 16.667, 3);
      lastTs = ts;
      if (!dragging) {
        v += (baseV - v) * 0.012 * dt; /* ease back to normal cruise */
        x += v * dt; /* positive v scrolls the strip leftward (forward) */
      }
      if (runWidth > 0) {
        x = ((x % runWidth) + runWidth) % runWidth;
        track.style.transform = 'translateX(' + -x + 'px)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    strip.addEventListener('pointerdown', function (e) {
      dragging = true;
      v = 0;
      lastPointerX = e.clientX;
      samples = [{ x: e.clientX, t: e.timeStamp }];
      strip.classList.add('is-dragging');
      strip.setPointerCapture(e.pointerId);
    });

    strip.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      x -= e.clientX - lastPointerX;
      lastPointerX = e.clientX;
      samples.push({ x: e.clientX, t: e.timeStamp });
      while (samples.length > 2 && e.timeStamp - samples[0].t > 120) samples.shift();
    });

    function release(e) {
      if (!dragging) return;
      dragging = false;
      strip.classList.remove('is-dragging');
      var a = samples[0];
      var b = samples[samples.length - 1];
      if (a && b && b.t > a.t) {
        var pxPerMs = (b.x - a.x) / (b.t - a.t);
        /* leftward fling (negative pxPerMs) must continue the strip forward;
           1.4 gain + high clamp = fidget-spinner feel */
        v = Math.max(-120, Math.min(120, -pxPerMs * (1000 / 60) * 1.4));
      } else {
        v = baseV;
      }
    }
    strip.addEventListener('pointerup', release);
    strip.addEventListener('pointercancel', release);
  }

  function boot() {
    document.querySelectorAll('[data-marquee]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
